import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchAllGames, GAMES_QUERY_KEYS } from './api.js';
import { fetchHotGames, HOT_GAMES_QUERY_KEY, pickHotGames } from './hot.js';

const REFRESH_MS = 60_000;

/** The ranked cards plus load state, shared by the section heading and the grid. */
export function useHotGames() {
  const slotGames = useQuery({
    queryKey: [...GAMES_QUERY_KEYS.list({ gameType: 'slot' }), 'all'],
    queryFn: () => fetchAllGames({ gameType: 'slot' }),
    staleTime: 60_000,
  });
  const hot = useQuery({
    queryKey: HOT_GAMES_QUERY_KEY,
    queryFn: fetchHotGames,
    staleTime: REFRESH_MS,
    refetchInterval: REFRESH_MS,
    refetchIntervalInBackground: false,
  });
  const games = useMemo(
    () => pickHotGames(hot.data?.items ?? [], slotGames.data ?? []),
    [hot.data, slotGames.data],
  );
  return { games, isPending: slotGames.isPending, isError: slotGames.isError };
}
